export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();
  const config = useRuntimeConfig();

  $i18n.setLocale(config.public.locale);
});
